import { createTemplateFromSet } from '@/api/services/templates';
import { DifficultyLevel } from '@/components/Template/types';
import { AxiosError } from 'axios';

type SaveTemplateFormData = {
  name: string;
  description: string;
  difficulty: DifficultyLevel;
  setType: 'Word' | 'Sentence';
  items: any[];
  onSuccess: () => void;
  showNotification: (options: {
    type: 'success' | 'error';
    title: string;
    message: string;
  }) => void;
};

export const handleTemplateCreationUtil = async ({
  name,
  description,
  difficulty,
  setType,
  items,
  onSuccess,
  showNotification,
}: SaveTemplateFormData): Promise<boolean> => {
  const payload = {
    name,
    description,
    difficulty,
    setType,
    items,
  };

  try {
    await createTemplateFromSet(payload);
    showNotification({
      type: 'success',
      title: `Die Vorlage ${name} wurde gespeichert.`,
      message: '',
    });
    onSuccess();
    return true;
  } catch (error) {
    const axiosError = error as AxiosError<any>;
    showNotification({
      type: 'error',
      title: axiosError.response?.data?.message?.includes('duplicate')
        ? 'Vorlage mit diesem Namen existiert bereits'
        : 'Fehler beim Speichern der Vorlage',
      message: '',
    });
    return false;
  }
};
